import React from "react";
import { FIELD_TYPE_OPTIONS } from "../../../../constants";
import { Grid, TypeCard, TypeTitle, TypeValue, TypeHint } from "./styles";

function FormFieldTypePicker({ onSelectType, disabledTypes = {} }) {
  return (
    <Grid>
      {FIELD_TYPE_OPTIONS.map((item) => {
        const disabledReason = disabledTypes[item.value];

        return (
          <TypeCard
            key={item.value}
            type="button"
            disabled={Boolean(disabledReason)}
            title={disabledReason || ""}
            onClick={() => !disabledReason && onSelectType(item.value)}
          >
            <TypeTitle>{item.label}</TypeTitle>
            <TypeValue>{item.value}</TypeValue>
            {disabledReason ? <TypeHint>{disabledReason}</TypeHint> : null}
          </TypeCard>
        );
      })}
    </Grid>
  );
}

export default FormFieldTypePicker;
